export default __webpack_public_path__ + "static/testimonial-bg-c096816cd2245ac35cecf6bc9891fc43.jpg";